import {TEventObject} from '../api/dataTypes';
import {actionCreator} from '../redux/reduxUtil';

export const setEvents = actionCreator<{
  events: TEventObject[];
}>('events.setEvents');
